import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useAppSelector } from '../../redux/store';

export const useParamMainBuyerId = () => {
  const params = useParams();
  const location = useLocation();
  const [selectedMainBuyerId, setSelectedMainBuyerId] = useState<string | null>(null);
  const { isPreviewMode, previewMainBuyer } = useAppSelector((state) => state.preview);

  useEffect(() => {
    if (isPreviewMode && previewMainBuyer) {
      setSelectedMainBuyerId(previewMainBuyer.id);
    } else if (params && params.mainBuyerId) {
      setSelectedMainBuyerId(params.mainBuyerId);
    } else {
      setSelectedMainBuyerId(null);
    }
    return () => {};
  }, [location.pathname]);

  return [selectedMainBuyerId];
};
